import React from 'react';
import AuthHeader from 'components/common/AuthHeader';
import PrivacyBody from 'components/PrivacyComponents/PrivacyBody/PrivacyBody';

const Privacy = () => {
  return (
    <>
      {/* -------- header ------------ */}
      <AuthHeader />

      {/* ---------- body --------- */}
      <PrivacyBody />
    </>
  );
};

export default Privacy;
